export interface Bonus {
  number: number
  title: string
  short: string
}

export const bonuses: Bonus[] = [
  {
    number: 1,
    title: 'Yoga Business Starter Guide™',
    short: 'Build a stronger foundation for your teaching career.',
  },
  {
    number: 2,
    title: 'Yoga Cueing & Transition Scriptbook™',
    short: 'Clearer cues, smoother transitions and more confident teaching.',
  },
  {
    number: 3,
    title: 'Yoga Student Retention Playbook™',
    short: 'Create stronger class experiences that keep students coming back.',
  },
  {
    number: 4,
    title: 'Yoga Business & Social Media Playbook™',
    short: 'Communicate your expertise and promote your teaching more professionally.',
  },
  {
    number: 5,
    title: 'Yoga Studio & Collaboration Guide™',
    short: 'Approach studios, build partnerships and expand your teaching opportunities.',
  },
]
